module.exports = __webpack_public_path__ + "img/prestige.aa7979d2.png";